<template>
  <mf-confirm-dialog
    v-model="open"
    :cancel-color="cancelColor"
    :cancel-text="cancelText"
    :confirm-color="confirmColor"
    :confirm-text="confirmText"
    dark
    :hide-cancel="hideCancel"
    :message="message"
    :title="title"
    @cancel="onCancel"
    @confirm="onConfirm"
  />
</template>

<script>
export default {
  data() {
    return {
      open: false,
    }
  },
}
</script>
